import { formatPhone } from '../../../utils';

interface CustomerCardProps {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  className?: string;
}

export function CustomerCard({ firstName, lastName, email, phone, className }: CustomerCardProps) {
  return (
    <div className={`p-4 shadow-sm border-0 card h-100 ${className ?? ''}`}>
      <p className="text-muted small text-uppercase fw-semibold mb-2">
        <i className="fa fa-user me-2"></i>Customer
      </p>
      {(firstName || lastName) && (
        <p className="fw-semibold mb-1">{firstName} {lastName}</p>
      )}
      {email && (
        <p className="text-muted small mb-0">
          <i className="fa fa-envelope me-2"></i>{email}
        </p>
      )}
      {phone && (
        <p className="text-muted small mb-0">
          <i className="fa fa-phone me-2"></i>{formatPhone(phone)}
        </p>
      )}
    </div>
  );
}
